import First from "../../../../../assets/images/project/rumah/YTM_HOUSE/yatim-house.jpg";

export default [
  {
    title: "YTM House",
    description: "Rumah modern minimalis model skandinavian Masa Kini",
    urls: First,
  },
];
